import React, { forwardRef, Ref } from 'react';
import { SimpleIconProps } from '../icon.types';
import Icon from './Icon';

const svg = `<svg viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none">
  <path d="M16 2v2"/>
  <path d="M7 22v-2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2"/>
  <path d="M8 2v2"/>
  <circle cx="12" cy="11" r="3"/>
  <rect x="3" y="4" width="18" height="18" rx="2"/>
</svg>`;

const Contacts = forwardRef(
  (props: SimpleIconProps, ref: Ref<SVGSVGElement> | undefined) => (
    <Icon ref={ref} name='contacts' svg={svg} {...props} />
  )
);

Contacts.displayName = 'ContactsIcon';

export default Contacts;
